import UserProfile from "pages/Authentication/user-profile";
import OldGoldDataList from "pages/Componets/Master/OldGoldRate/components/OldGoldDataList";
import BillSettingMaster from "pages/Componets/Store/BillSetting/BillSettingMaster";
import StoreOperationDataList from "pages/Componets/Store/StoreOperationRoles/StoreOperationDataList";
import { lazy } from "react";
import { Navigate } from "react-router-dom";
import LoginRedirectWrapper from "./authHook/LoginRedirectWrapper";
import DiscountMasterDataList from "pages/Componets/Discount/DiscountMain/components/DiscountMasterDataList";
import DiscountVoucherDataList from "pages/Componets/Discount/DiscountVoucher/components/DiscountVoucherDataList";
import SalesEntryList from "pages/Componets/Transaction/SalesEnrtyList/components/SalesInventryList";
import RreturnOrderList from "pages/Componets/Transaction/ReturnSalesEntry/components/ReturnOrderList";
import SubCategoryDataList from "pages/Componets/Product/SubCategory/SubcategoryMainList";
import InterStoreOrderList from "pages/Componets/InterStore/InterStoreOrderList/components/InterStoreOrderList";
import StoreLedger from "pages/Componets/Ledger/StoreLadger/StoreLeadger";
import CustomerLedger from "pages/Componets/Ledger/CutomerLedger/CustomerLedger";
import ReturnPolicySection from "pages/Dashboard/ReturnPolicy/ReturnPolicySection";
import VendorMasteList from "pages/Componets/ItemMaster/components/vendor/VendorMasterList";
import MakingTypeList from "pages/Componets/ItemMaster/components/makingType/MakingTypeList";
import ItemMasterList from "pages/Componets/ItemMaster/ItemMasterList";
import InwardFromVendor from "pages/Componets/ItemMaster/components/InwardFromVendor/InwardFromVendor";
import InwardFromVendorProcess from "pages/Componets/ItemMaster/components/InwardFromVendor/components/InwardFromVendorProcess";
import ProductList from "pages/Componets/poProcess/ProductList";
import POordersList from "pages/Componets/POorders/POordersList";
import POInward from "pages/Componets/poStock/components/poInward";
import POInventory from "pages/Componets/poStock/components/poInventory";
import RejectedProducts from "pages/Componets/poStock/components/RejectedProducts";
import AssignProducts from "pages/Componets/poStock/components/AssignProducts";
import EditPoInwardProduct from "pages/Componets/poStock/components/EditPoInwardProduct";
import AddItem from "pages/Componets/ItemMaster/components/itemMaster/AddItem";
import ReturnSalesOrderDetails from "pages/Componets/ReturnSalesOrder/components/ReturnSalesOrderDetails";
// import KtConversionDataList from "pages/Componets/Master/KtConversion/components/KtConversionDataList";
// Lazy-loaded components
// Auth Protected routes :
const Analytics = lazy(() => import("pages/Dashboard/Analytics"));
const Login = lazy(() => import("pages/Authentication/Login"));
const Logout = lazy(() => import("pages/Authentication/Logout"));
// Public routes
const CustomerMasterDataList = lazy(
  () => import("pages/Componets/Customer/CustomerMain/CustomerMasterDataList")
);
const UserMasterDataList = lazy(
  () => import("pages/Componets/User/UserMaster/UserDataList")
);
const RoleDataList = lazy(
  () => import("pages/Componets/User/RoleMaster/RoleDataList")
);
const KaratMasterDataList = lazy(
  () => import("pages/Componets/Master/Karat/KaratMasterDataList")
);
const MetalMasterDataList = lazy(
  () => import("pages/Componets/Master/MetalMaster/MetalMasterDataList")
);
const GoldRateDataList = lazy(
  () => import("pages/Componets/Master/GoldRateMain/GoldRateDataList")
);
const DiamondRateMain = lazy(
  () => import("pages/Componets/DiamondRate/DiamondRateMain")
);
const OldGoldPurchaseRateMasterMain = lazy(
  () => import("pages/Componets/OldGoldPurchaseRate/OldGoldPurchaseRateMain")
);
const CategoryDataList = lazy(
  () => import("pages/Componets/Product/Category/CategoryDataList")
);
const CollectionDataList = lazy(
  () => import("pages/Componets/Product/Collection/CollectionDataList")
);
const CompanyDataList = lazy(
  () => import("pages/Componets/Product/Company/CompanyDataList")
);
const DiamondShapeDataList = lazy(
  () => import("pages/Componets/Product/DiamondShape/DiamondShapeDataList")
);
const MetalColorDataList = lazy(
  () => import("pages/Componets/Product/MetalColor/MetalColorDataList")
);
const MaterialTypeDataList = lazy(
  () => import("pages/Componets/Master/MaterialType/MaterialTypeDataList")
);
const StyleMasterDataList = lazy(
  () => import("pages/Componets/Product/StyleMaster/StyleMasterDataList")
);
const GoldMakingChargesDataList = lazy(
  () =>
    import(
      "pages/Componets/MakingCharges/GoldMakingCharges/GoldMakingChargesDataList"
    )
);
const DiamondMakingChargesDataList = lazy(
  () =>
    import(
      "pages/Componets/MakingCharges/DiamondMakingCharges/DiamondMakingChargesDataList"
    )
);
const CountryDataList = lazy(
  () => import("pages/Componets/Directory/CountryMaster/CountryDataList")
);
const StateDataList = lazy(
  () => import("pages/Componets/Directory/StateMaster/StateDataList")
);
const CityDataList = lazy(
  () => import("pages/Componets/Directory/CityMaster/CityDataList")
);
const StoreDataList = lazy(
  () => import("pages/Componets/Store/StoreMaster/StoreDataList")
);
const SalesPersonDataList = lazy(
  () => import("pages/Componets/Store/SalePerson/SalesPersonDataList")
);
const BillTypeDataList = lazy(
  () => import("pages/Componets/Store/BillType/BillTypeDataList")
);
const RejectReasonDataList = lazy(
  () => import("pages/Componets/Master/RejectReason/RejectReasonDataList")
);
const EarningRewardDataList = lazy(
  () =>
    import(
      "pages/Componets/Discount/Reward/RewardEarning/EarningRewardDataList"
    )
);
const RedemptionRewardDataList = lazy(
  () =>
    import(
      "pages/Componets/Discount/Reward/RewardRedemption/RedemptionRewardDataList"
    )
);
const DiscountMasterMain = lazy(
  () => import("pages/Componets/Discount/DiscountMain/DiscountMasterMain")
);
// const DiscountVoucherMasterMain = lazy(
//   () => import("pages/Componets/Discount/DiscountVoucher/DiscountVoucherMaster")
// );
const EnquiryMasterMain = lazy(
  () => import("pages/Componets/Transaction/EnquiryMaster/EnquiryMasterMain")
);
const ReturnDeductionMaster = lazy(
  () =>
    import("pages/Componets/Deduction/ReturnDeduction/ReturnDeductionMaster")
);
const PaymentTypeDataList = lazy(
  () => import("pages/Componets/Master/PaymentType/PaymentTypeDataList")
);
const WalkInSourceDataList = lazy(
  () => import("pages/Componets/Master/WalkInSource/WalkSourceDataList")
);
const RepairWorkDataList = lazy(
  () => import("pages/Componets/Master/RepairWork/RepairWorkDataList")
);
const ProductHeaderDataList = lazy(
  () => import("pages/Componets/Product/ProductHeader/ProductHeaderDataList")
);
const ProductDetailsDataList = lazy(
  () => import("pages/Componets/Product/ProductDetails/ProductDetailsDataList")
);
const DeductionDataList = lazy(
  () => import('pages/Componets/Master/DeductionMaster/component/DeductionDataList')
)

const ReturnSalesOrderDataList = lazy(
  () => import('pages/Componets/ReturnSalesOrder/components/ReturnSalesList')
)

const authProtectedRoutes = [
  // Dashboard
  { path: "/dashboard", component: <Analytics />, permissionTitle: "Dashboard" },
  { path: "/", element: <Navigate to="/dashboard" replace /> },
  { path: "*", component: <Navigate to="/dashboard" /> },
  // Module.1 - Dashboard #
  { path: "/dashboard", name: "Analytics Dashboard", component: <Analytics />, permissionTitle: "Dashboard", },
  // Master
  {
    path: "/user-master",
    name: "User Master",
    component: <UserMasterDataList />,
    permissionTitle: "User",
  },
  {
    path: "/role-master",
    name: "Role Master",
    component: <RoleDataList />,
    permissionTitle: "UserRole",
  },
  // {
  //   path: "/kt-conversion-master",
  //   name: "kt Conversion Master",
  //   component: <KtConversionDataList />,
  //   permissionTitle: "Karat",
  // },
  // Rate
  {
    path: "/karat-master",
    name: "Karat Master",
    component: <KaratMasterDataList />,
    permissionTitle: "Karat",
  },
  {
    path: "/metal-master",
    name: "Metal Master",
    component: <MetalMasterDataList />,
    permissionTitle: "Metal",
  },
  {
    path: "/gold-rate",
    name: "Gold Rate",
    component: <GoldRateDataList />,
    permissionTitle: "GoldRateMaster",
  },
  {
    path: "/diamond-rate",
    name: "Diamond Rate",
    component: <DiamondRateMain />,
    permissionTitle: "DiamondMakingCharges",
  },
  {
    path: "/old-gold-purchase-rate",
    name: "Old Gold Purchase Rate",
    component: <OldGoldPurchaseRateMasterMain />,
    permissionTitle: "OldGoldPurchaseRate",
  },
  {
    path: "/category",
    name: "Category",
    component: <CategoryDataList />,
    permissionTitle: "Category",
  },

  {
    path: "/subcategory",
    name: "SubCategory",
    component: <SubCategoryDataList />,
    permissionTitle: "Category",
  },

  {
    path: "/collection",
    name: "Collection",
    component: <CollectionDataList />,
    permissionTitle: "Collection",
  },
  // {
  //   path: "/company",
  //   name: "Company",
  //   component: <CompanyDataList />,
  //   permissionTitle: "Company",
  // },
  // {
  //   path: "/diamond-shape",
  //   name: "Diamond Shape",
  //   component: <DiamondShapeDataList />,
  //   permissionTitle: "DiamondShape",
  // },
  {
    path: "/metal-color",
    name: "Metal Color",
    component: <MetalColorDataList />,
    permissionTitle: "MetalColor",
  },
  {
    path: "/material-type",
    name: "Material Type",
    component: <MaterialTypeDataList />,
    permissionTitle: "MaterialType",
  },
  {
    path: "/style-master",
    name: "Style Master",
    component: <StyleMasterDataList />,
    permissionTitle: "StyleMaster",
  },
  {
    path: "/deduction",
    name: "Deduction Master",
    component: <DeductionDataList />,
    permissionTitle: "DeductionMaster",
  },
  // Customer
  {
    path: "/customer",
    name: "Customer",
    component: <CustomerMasterDataList />,
    permissionTitle: "Customer",
  },
  {
    path: "/walk-in-source",
    name: "Walk In Source",
    component: <WalkInSourceDataList />,
    permissionTitle: "WalkInSource",
  },
  // Product
  {
    path: "/product-header",
    name: "Product_Header",
    component: <ProductHeaderDataList />,
    permissionTitle: "ProductHeader",
  },
  {
    path: "/product-details",
    name: "Product_Details",
    component: <ProductDetailsDataList />,
    permissionTitle: "ProductDetails",
  },
  // Making Charges
  {
    path: "/gold-making-charges",
    name: "Gold Making Charges",
    component: <GoldMakingChargesDataList />,
    permissionTitle: "GoldMakingCharges",
  },
  {
    path: "/diamond-making-charges",
    name: "Diamond Making Charges",
    component: <DiamondMakingChargesDataList />,
    permissionTitle: "DiamondMakingCharges",
  },
  // Directory
  {
    path: "/country-directory",
    name: "Country Directory",
    component: <CountryDataList />,
    permissionTitle: "Country",
  },
  {
    path: "/state-directory",
    name: "State Directory",
    component: <StateDataList />,
    permissionTitle: "StateProvince",
  },
  {
    path: "/city-directory",
    name: "City Directory",
    component: <CityDataList />,
    permissionTitle: "City",
  },
  // Reject Reason
  // {
  //   path: "/reject-reason",
  //   name: "Reject Reason",
  //   component: <RejectReasonDataList />,
  //   permissionTitle: "RejectReason",
  // },
  // Store
  {
    path: "/StoreOpsRole",
    name: "Store Ops Role",
    component: <StoreOperationDataList />,
    permissionTitle: "StoreOpsRole",
  },
  {
    path: "/store",
    name: "State Master",
    component: <StoreDataList />,
    permissionTitle: "Store",
  },
  // Sales
  {
    path: "/sales-person",
    name: "Sales",
    component: <SalesPersonDataList />,
    permissionTitle: "SalesPerson",
  },
  {
    path: "/bill-type",
    name: "Bill Type",
    component: <BillTypeDataList />,
    permissionTitle: "BillType",
  },
  {
    path: "/bill-setting",
    name: "Bill Setting",
    component: <BillSettingMaster />,
    permissionTitle: "BillSetting",
  },
  // Rewards
  {
    path: "/earning-rewards",
    name: "Earning Rewards",
    component: <EarningRewardDataList />,
    permissionTitle: "EarningSetting",
  },
  {
    path: "/redemption-rewards",
    name: "Redemption Rewards",
    component: <RedemptionRewardDataList />,
    permissionTitle: "RedemptionSetting",
  },
  // Discount
  {
    path: "/discount",
    name: "Discount",
    component: <DiscountMasterDataList />,
    permissionTitle: "ConsumerOffers",
  },
  {
    path: "/discount-voucher",
    name: "Discount-voucher",
    component: <DiscountVoucherDataList />,
    permissionTitle: "DiscountVoucher",
  },
  // Transactions
  {
    path: "/transaction-enquiry",
    name: "Transaction Enquiry",
    component: <EnquiryMasterMain />,
    permissionTitle: "Enquiry",
  },
  {
    path: "/sales-entry-list",
    name: "Sales Entry List",
    component: <SalesEntryList />,
    // permissionTitle: "",
  },
  {
    path: "/return-order-list",
    name: "Return Order List",
    component: <RreturnOrderList />,
    // permissionTitle: "",
  },
  // Return Deduction
  {
    path: "/return-deduction",
    name: "Return Deduction",
    component: <ReturnDeductionMaster />,
    permissionTitle: "ReturnDeduction",
  },
  // Payment Type
  // {
  //   path: "/payment-type",
  //   name: "Payment Type",
  //   component: <PaymentTypeDataList />,
  //   permissionTitle: "PaymentType",
  // },
  // Repair Work
  {
    path: "/repair-work",
    name: "Repair Work",
    component: <RepairWorkDataList />,
    permissionTitle: "RepairWork",
  },
  // {
  //   path: "/old-gold-rate",
  //   name: "Old Gold Rate",
  //   component: <OldGoldDataList />,
  //   permissionTitle: "RepairWork",
  // },
  // Inventory (placeholder permission)
  {
    path: "/diamond-product-inventory",
    name: "Diamond Product Inventory",
    component: <Analytics />,
    permissionTitle: "Inventory",
  },
  {
    path: "/gold-product-inventory",
    name: "Gold Product Inventory",
    component: <Analytics />,
    permissionTitle: "Inventory",
  },
  {
    path: "/user-profile",
    name: "User Profile",
    component: <UserProfile />,
    permissionTitle: "UserRole",
  },

  {
    path: "/interstore",
    name: "Inter Store Order List",
    component: <InterStoreOrderList />,
    permissionTitle: "UserRole",
  },

  {
    path: "/storeLedger",
    name: "Store Ledger List",
    component: <StoreLedger />,
    permissionTitle: "UserRole",
  },
  {
    path: "/customerLedger",
    name: "Cutomer Ledger List",
    component: <CustomerLedger />,
    permissionTitle: "UserRole",
  },
  {
    path: "/return-policy",
    name: "return-policy",
    component: <ReturnPolicySection />
  },
  // Item Master
  {
    path: "/vendor-master",
    name: "Vendor Master",
    component: <VendorMasteList />,
    permissionTitle: "Master",
  },
  {
    path: "/making-type",
    name: "Making Type Master",
    component: <MakingTypeList />,
    permissionTitle: "Master",
  },
  {
    path: "/item-master",
    name: "Item Master",
    component: <ItemMasterList />,
    permissionTitle: "Master",
  },
  {
    path: "/po-process",
    name: "PO process",
    component: <ProductList />,
    permissionTitle: "Master",
  },
  {
    path: "/po-orders",
    name: "PO orders",
    component: <POordersList />,
    permissionTitle: "Master",
  },
  {
    path: "/po-inward",
    name: "PO Inward",
    component: <POInward />,
    permissionTitle: "Master",
  },
  {
    path: "/add-item",
    name: "Add Item master",
    component: <AddItem />,
    permissionTitle: "Master",
  },
  {
    path: "/po-inward/edit/:id/:productName/:materialType",
    name: "PO Inward Edit",
    component: <EditPoInwardProduct />,
    permissionTitle: "Master",
  },
  {
    path: "/po-inventory",
    name: "PO Inward",
    component: <POInventory />,
    permissionTitle: "Master",
  },
  {
    path: "/rejected-products",
    name: "Rejected Product",
    component: <RejectedProducts />,
    permissionTitle: "Master",
  },
  {
    path: "/assign-products",
    name: "Assigned Products",
    component: <AssignProducts />,
    permissionTitle: "Master",
  },
  {
    path: "/inward-from-vendor",
    name: "Inward from Vendor ",
    component: <InwardFromVendor />,
    permissionTitle: "Master",
  },
  {
    path: "/inward-from-vendor-process/:id",
    name: "Inward from Vendor ",
    component: <InwardFromVendorProcess />,
    permissionTitle: "Master",
  },
  {
    path: "/return-sales-order",
    name: "Return Sales Order",
    component: <ReturnSalesOrderDataList />,
    permissionTitle: "Master",
  },
  {
    path: "/return-sales-order/:id/details",
    name: "Return Sales Order Details",
    component: <ReturnSalesOrderDetails />,
    permissionTitle: "Master",
  },
];
const publicRoutes = [
  // Authentication
  { path: "/login", name: "Login", component: <LoginRedirectWrapper /> },
  { path: "/logout", name: "Logout", component: <Logout /> },
];
export { authProtectedRoutes, publicRoutes };